import React, { Fragment, useState, useEffect, useRef, useCallback } from 'react';
import { getQuery } from './publicationQueryBuilder';
import { getColumnsAGGrid, getExportColumns } from './publicationColumns';
import SparqlHook from '../../SparqlHook.js';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { tableOverlays } from '../../config';
import { LoadingDots, niceDate, kdpPublicationStageToCaption, publicationTitleLabel, numberToT, formatNumber } from '../../helpers/utils';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as XLSX from 'xlsx';

const Publications = (props) => {
    const [rowData, setRowData] = useState();
    const gridRef = useRef(null);
    const columns = getColumnsAGGrid(props);
    const exportColumns = getExportColumns(props);
    const { runQuery } = SparqlHook();

    function refreshData()
    {
      // console.log('Publication(getQuery', getQuery(props));
      runQuery({ query: getQuery(props)})
      .then(result => {
        setRowData(result);
          if(result) {
            setRowData(result);
          }
      })
      ;
    }

    useEffect(() => {
      if(props.filter.initialized) {
        setRowData(undefined);
        refreshData();
      } else {
        setRowData([]);
      }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.filter.searchIssued?.toString()])

    const exportToExcel = useCallback(() => {
      if (!rowData || rowData.length === 0) {
        return;
      }

      // Transform data for export using export column definitions
      const exportData = rowData.map(row => {
        const exportRow = {};
        exportColumns.forEach(col => {
          let value = row[col.field];

          // Apply formatters for specific columns
          if (col.field === 'downloaded' || col.field === 'kdqLastmod') {
            value = niceDate(value, 1);
          } else if (col.field === 'processStage') {
            value = kdpPublicationStageToCaption(value);
          } else if (col.field === 'title') {
            value = publicationTitleLabel(value, row.shortDescription);
          } else if (col.field === 'totalValue' && value) {
            value = numberToT(value, 0);
          } else if (col.field === 'contractorPublicationName') {
            // Use resolved name if available, otherwise publication name
            value = row.contractorName || row.contractorPublicationName || '';
          } else if (col.field === 'contractingBodyNamePublication') {
            // Use resolved name if available, otherwise publication name
            value = row.contractingBodyName || row.contractingBodyNamePublication || '';
          }

          exportRow[col.headerName] = value || '';
        });
        return exportRow;
      });

      // Create workbook and worksheet
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Veröffentlichungen');

      // Auto-size columns
      const colWidths = exportColumns.map(col => ({
        wch: Math.max(col.headerName.length, 15)
      }));
      worksheet['!cols'] = colWidths;

      // Generate filename with current date
      const date = new Date().toISOString().split('T')[0];
      const filename = `veroeffentlichungen_${date}.xlsx`;

      // Download file
      XLSX.writeFile(workbook, filename);
    }, [rowData, exportColumns]);

  return (
    <Fragment>
      {rowData ?
        <Fragment>
          <div className="mb-2 d-flex justify-content-between align-items-center">
            <span className="text-muted">{formatNumber(rowData.length)} Ergebnisse</span>
            <Button
              color="secondary"
              size="sm"
              onClick={exportToExcel}
              disabled={rowData.length === 0}
            >
              <FontAwesomeIcon icon="file-excel" className="mr-1" />
              Excel Export
            </Button>
          </div>
          <div className="ag-theme-alpine" style={{ height: '100%', width: '100%' }}>
            <AgGridReact
              ref={gridRef}
              rowData={rowData}
              defaultColDef={{ sortable: true, filter: true, resizable: true }}
              columnDefs={columns}
              overlayNoRowsTemplate={tableOverlays.overlayNoRowsTemplate}
              overlayLoadingTemplate={tableOverlays.overlayLoadingTemplate}
              domLayout="autoHeight"
            />
          </div>
        </Fragment>
      :
        <Fragment><LoadingDots></LoadingDots></Fragment>
      }
    </Fragment>
  );
};

export default Publications;